import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=0cfa82b2&scoped=true&"
import script from "./Directories.vue?vue&type=script&lang=js&"
export * from "./Directories.vue?vue&type=script&lang=js&"
import style0 from "./Directories.vue?vue&type=style&index=0&id=0cfa82b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa82b2",
  null
  
)

export default component.exports